
    declare var grecaptcha: any;
    import axios, { AxiosResponse } from 'axios';
    import { defineComponent } from 'vue';

    export class DCForgotPasswordResult {
        public IsGood: boolean = false;
        public ErrorMsg: string = "";
    }

    export default defineComponent({
        data() {
            return {
                pass_usernameoremail: "",
                isregister: false,
                statuterr:""
            };
        },
        props: {
            currentlang: String,
            dclang_mcforgotpasswordmailreu: String,
            dclang_registerpseudooremail: String,
            dclang_mcbuttonok: String,
            dclang_statuterr:String
        },
        mounted() {

        },
        methods: {

            async LoginPostLoad() {
                var datapost = {
                    m_lang: this.currentlang,
                    pass_usernameoremail: this.pass_usernameoremail
                };
                let self = this;
                const response = await axios.post<DCForgotPasswordResult>("/api/v1/login/ForgotPassword", datapost);
                self.isregister = response.data.IsGood;
                    if (!response.data) {
                        if (self.dclang_statuterr != null)
                            self.statuterr = self.dclang_statuterr;
                    }
                    else
                        self.statuterr = response.data.ErrorMsg;
                return false;
            }
        }
    });
